import { render, staticRenderFns } from "./supplierServiceTermsModal.vue?vue&type=template&id=8be786d2&scoped=true"
import script from "./supplierServiceTermsModal.vue?vue&type=script&lang=js"
export * from "./supplierServiceTermsModal.vue?vue&type=script&lang=js"
import style0 from "./supplierServiceTermsModal.vue?vue&type=style&index=0&id=8be786d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be786d2",
  null
  
)

export default component.exports